import * as styledComponents from 'styled-components';

import blackTheme from './black';
import whiteTheme from './white';

export interface IThemeInterface {
  primary: string;
  componentBackground: string;
  componentBackgroundSecondary: string;
}

export const theme = {
  default: {
    minWidth: 1024,
    primary: '#fff',
    background: '#fff',
    disableBackground: '#788586',
    componentBackground: '#fff',
    componentBackgroundSecondary: '#fff',
    radius: 0.358,
    padding: 4,
    verticalMargin: '16px',
    fontSize1: '1.275rem',
    fontSize2: 18,
    fontSize3: 12,
    rowPadding1: 4,
    rowPadding2: 8,
    rowPadding3: 12,
    rowPadding4: 20,
    formPadding: '1.5rem 2rem',
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#1db53a',
        focus: '#30B843',
        alert: '#FF8787',
        light: '#0066ff',
        dark: '#008329',
        contrastText: '#fff'
      },
      secondary: {
        light: '#0066ff',
        main: '#e20b44',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#ffcc00'
      },
      common: {
        black: '#222',
        main: '#E4E6EF',
        light: '#E4E6EF'
      },
      text: {
        primary: '#222',
        secondary: '#707371'
      },
      grey: {
        100: '#f9f9f9'
        // 200: '#cccccc'
      }
    },
    topMenuFontFamily: 'Apple SD Gothic Neo',
  },
  white: whiteTheme,
  black: blackTheme
};


const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<
  IThemeInterface
>;

export { ThemeProvider };
